import HeaderBar from "./components/headerBar";
import NavTabs from "./components/navTabs";
import { useState } from "react";
import Overview from "./dashboard/overview";
import Assignments from "./dashboard/assignment";

const StudentDashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "assignments", label: "Assignments" }
  ];

  return (
    <section className="cht-animate-in cht-fade-in cht-duration-700">
      <HeaderBar pageHeader="Dashboard">
        <NavTabs 
          tabs={tabs} 
          activeTab={activeTab} 
          onTabSelect={setActiveTab} 
        />
      </HeaderBar>

      <main className="cht-container cht-mx-auto">
        <section className="cht-mb-12">
          {activeTab === "overview" && <Overview onSwitchTab={setActiveTab} />}

          {activeTab === "assignments" && <Assignments />}
        </section>
      </main>
    </section>
  );
};

export default StudentDashboard;
